import React, { useContext, useEffect, useState } from 'react'
import 'chartjs-adapter-date-fns'
import { RiRegisteredLine } from 'react-icons/ri'
import { FaWpforms } from 'react-icons/fa'
import { apiGet } from 'utils/apiFetch'
import apiPath from 'utils/apiPath'
import CountUp from 'react-countup'
import { useTranslation } from 'react-i18next'
import AuthContext from 'context/AuthContext'
import { Link } from 'react-router-dom'
import useToastContext from 'hooks/useToastContext'
 
function HRHome () {
  const { t } = useTranslation()
  const notification = useToastContext()
  let { logoutUser, updatePageName, profileCompletion } = useContext(AuthContext)
 
  const [dashboardDetails, setDashboardDetails] = useState({})
 
  const getDashboardHRDetails = async () => {
    try {
      const payload = {}
      const path = apiPath.getDashboardHRDetails
      const result = await apiGet(path, payload)
      setDashboardDetails({ ...dashboardDetails, ...result.data.results })
    } catch (error) {
      console.log('error:', error)
    }
  }
 
  const getHRCompletionStatus = async () => {
    try {
      const path = apiPath.hrCompletionStatus
      const result = await apiGet(path, {})
     
      if (result.data.success) {
        const message = result.data.results.message;
       
        if (message === "Add your first employee") {
          updatePageName(
            <span>
              {t('NAV_DASHBOARD')}.
            </span>
          )
        } else {
          updatePageName(
            <span>
              {t('NAV_DASHBOARD')}
            </span>
          )
        }
      }
    } catch (error) {
      console.log('Error fetching HR status:', error)
    }
  }
 
  useEffect(() => {
    getDashboardHRDetails()
    getHRCompletionStatus()
  }, [])
 
  return (
    <>
      <div className='md:px-8 py-4 px-4'>
        <div className='3xl:grid-cols-4 gap-4 2xl:grid-cols-3 sm:grid-cols-2 mb-7 sale_report grid'>
          <Link
            to='/all-employee-list'
            state={'accepted'}
            onClick={() => updatePageName(t('NAV_ALL_EMPLOYEE_LIST'))}
          >
            <div className='flex items-center sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg py-4 md:py-8 border'>
              <h3 className='xl:flex block font-bold md:text-2xl sm:text-lg text-lg items-center mb-0 text-slate-900'>
                {dashboardDetails?.totalFinalEmp ? (
                  <CountUp end={dashboardDetails?.totalFinalEmp} duration={0.6} />
                ) : ( 0 )}
                <span className='lg:ml-4 block lg:inline-block text-gray-900 text-base font-normal'>
                  {t('TOTAL_FINAL_EMPLOYEES')}
                </span>
              </h3>
              <span className='ml-auto sm:mr-0 mt-2 sm:mt-0 text-4xl '>
                <RiRegisteredLine />
              </span>
            </div>
          </Link>
          <Link to='/leave-manager' onClick={() => updatePageName(t('LEAVES_MANAGER'))}>
            <div className='flex items-center sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg py-4 md:py-8 border'>
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg'>
                {dashboardDetails?.totalLeaveApplied ? (
                  <CountUp duration={0.6} end={dashboardDetails?.totalLeaveApplied} />
                ) : ( 0 )}
                <span className='lg:ml-4 text-base text-gray-900 font-normal block lg:inline-block'>
                  {t('TOTAL_LEAVES_APPLIED_BY_EMPLOYEES')}
                </span>
              </h3>
              <span className='text-4xl ml-auto sm:mr-0 mt-2 sm:mt-0'>
                <FaWpforms />
              </span>
            </div>
          </Link>
          <Link to='/leave-manager' state={'accepted'} onClick={() => updatePageName(t('LEAVES_MANAGER'))}>
            <div className='flex items-center sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg py-4 md:py-8 border'>
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg'>
                {dashboardDetails?.totalLeaveAccepted ? (
                  <CountUp duration={0.6} end={dashboardDetails?.totalLeaveAccepted} />
                ) : ( 0 )}
                <span className='lg:ml-4 text-base text-gray-900 font-normal block lg:inline-block'>
                  {t('TOTAL_LEAVES_ACCEPTED_BY_EMPLOYEES')}
                </span>
              </h3>
              <span className='text-4xl ml-auto sm:mr-0 mt-2 sm:mt-0'>
                <FaWpforms />
              </span>
            </div>
          </Link>
        </div>
      </div>
    </>
  )
}
 
export default HRHome